import { IconCopy, IconWallet, IconX } from "@tabler/icons-react";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  Stack,
} from "@mui/material";

import {
  formatDate,
  formatPaymentStatus,
  formatPrice,
} from "../helpers/format";

import Info from "./Info";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "react-toastify";

const ModalFinanceDetails = ({ data, onClose, open, showPix }: any) => {
  return (
    <Dialog maxWidth="xs" fullWidth open={open}>
      <DialogTitle>
        <Stack>
          <Stack
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            Pagamento pedido #{data?.orderId}{" "}
            <Stack>
              <IconButton onClick={() => onClose()}>
                <IconX />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={2}>
          <Info
            size={4}
            title={"Status"}
            subTitle={formatPaymentStatus(data?.status)}
          />
          <Info
            size={4}
            title={"Valor da fatura"}
            subTitle={formatPrice(data?.value)}
          />
          <Info
            size={4}
            title={"Vencimento"}
            subTitle={formatDate(data?.dueDate)}
          />
          {showPix && (
            <Grid2
              size={12}
              mt={2}
              justifyContent={"center"}
              alignItems={"center"}
              display={"flex"}
            >
              <Stack
                justifyContent={"center"}
                alignItems={"center"}
                display={"flex"}
                sx={{
                  padding: "0.5rem",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                  width: "220px",
                }}
              >
                <QRCodeCanvas
                  value={data?.bankPixCode || ""}
                  style={{ width: "200px", height: "200px" }}
                />
              </Stack>
            </Grid2>
          )}
        </Grid2>
        <Grid2 size={12} mt={2}>
          <Stack gap={1}>
            {showPix && (
              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 2 }}
                color="info"
                endIcon={<IconCopy />}
                onClick={async () => {
                  await navigator.clipboard.writeText(data?.bankPixCode);
                  toast.info("PIX Copiado");
                }}
              >
                Copiar pix
              </Button>
            )}

            {data?.webToken && (
              <Button
                endIcon={<IconWallet />}
                variant="contained"
                color="success"
                fullWidth
                onClick={() => {
                  window.open("/i/" + data?.webToken);
                }}
              >
                Link de pagamento
              </Button>
            )}
          </Stack>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export default ModalFinanceDetails;
